import React, { useState, useEffect } from 'react'
import { GeneralModal, Button, Toaster, GeneralTable, MultiFilters, FormInput_text, Dropdown, ListBox } from 'components';
import { useOutletTableColumns } from './useOutletTableColumns';
import { isArrayEmpty, isArrayNotEmpty, isObjectEmpty, isStringNotEmpty } from 'functions';

export default function useAddKey({
    keyList, selectedkeyList, setSelectedKeyList
}) {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalKeyList, setmodalKeyList] = useState([]);
    const [category, setcategory] = useState("All");
    const [outletName, setoutletName] = useState();
    
    useEffect(() => {
      if(isModalVisible) {
        setmodalKeyList(
            keyList.map(key => {
                return {
                    label: key.chargeValue, 
                    data: key,
                    isSelected: false
                }
            })
        )
      }
    }, [isModalVisible])
    
    useEffect(() => {
        if(isArrayNotEmpty(keyList)) {
            let filtered_keyList = [...keyList]

            // filter by category
            if(isStringNotEmpty(category) && category !== "All") {
                if(category === "Outlet") {
                    filtered_keyList = filtered_keyList.filter(obj => {
                        if(obj?.category === "Outlet") {
                            return obj
                        }
                    })
                }
                else if(category === "License") {
                    filtered_keyList =  filtered_keyList.filter(obj => {
                        if(obj?.category !== "Outlet") {
                            return obj
                        }
                    })
                }
            }

            // filter by name
            if(isStringNotEmpty(outletName)) {
                let lowerOutletName = outletName.toLowerCase();
                filtered_keyList = filtered_keyList.filter(obj => {
                    if(obj?.chargeValue.toLowerCase().includes(lowerOutletName)) {
                        return obj
                    }
                })
            }

            const selectedId = new Set(selectedkeyList.map(obj => obj.chargeValue));
            setmodalKeyList(
                filtered_keyList.map(key => {
                    return {
                        label: key.chargeValue, 
                        data: key,
                        isSelected: selectedId.has(key.chargeValue)
                    }
                })
            )
        }
    }, [category, outletName])
    
    let modalDisplay = (
        <GeneralModal
            modalWapperClassName={"commitment-pay-setup__addKeyModal"}
            isModalVisible={isModalVisible}

            title={"Add Key"}
            headerClassName={"commitment-pay-setup__addKeyModal-header"}
            bodyClassName={"overflow-auto"}
            updateParentState={setIsModalVisible}

            bodyWrapperClassName={"commitment-pay-setup__addKeyModal-bodyWrapper"}
            contentClassName={"commitment-pay-setup__addKeyModal-content"}
            content={(
                <React.Fragment>
                    {/* Available Outlet */}
                    <div>
                        <div className={"d-flex"}>
                            <Dropdown
                                className={"mr-4"}
                                options={[
                                    { label: "All", value: "All" },
                                    { label: "Outlet", value: "Outlet" },
                                    { label: "License", value: "License" }
                                ]}
                                selectedValue_default={category}
                                onChange={(value, label) => {
                                    setcategory(value)
                                }}
                                label={"Category"}
                                isLabelLegend isSearchable isClearable isInputRequired
                                isResetRequired={isModalVisible}
                            />
                            <FormInput_text
                                className={"outlet_name w-50"}
                                inputLabel={"Outlet Name"}
                                inputValue={outletName}
                                propagateValueChange={(stateName, value) => { setoutletName(value); }}
                                isResetRequired={isModalVisible}
                            />
                        </div>
                        <ListBox
                            list={modalKeyList}
                            listBodyClassName={"w-100"}
                            onHandleOnCheckBoxChange={(isChecked, isMain, data) => {
                                if(isMain) {
                                    if(isChecked) {
                                        setSelectedKeyList(prevState => [...prevState, ...modalKeyList.map(obj => obj.data)])
                                    }
                                    else {
                                        const listId = new Set(modalKeyList.map(obj => obj.data.chargeValue))
                                        setSelectedKeyList(selectedkeyList.filter(obj => !listId.has(obj.chargeValue)))
                                    }
                                }
                                else {
                                    if(isChecked) {
                                        setSelectedKeyList(prevState => [...prevState, data])
                                    }
                                    else {
                                        setSelectedKeyList(selectedkeyList.filter(obj => obj.chargeValue !== data.chargeValue))
                                    }
                                }
                            }}
                            isResetRequired={isModalVisible}
                        />
                    </div>
                </React.Fragment>
            )}

            footerClassName={"commitment-pay-setup__addKeyModal-footer"}
            confirmButtonText={"Add"}
            footerCancelWrapperClassName={"px-2"}
            footerCancelClassName={"commitment-pay-setup__addKeyModal-footer__cancel-button"}
            footerConfirmWrapperClassName={"px-2"}
            cancelButtonText={"Cancel"}
            handleOnConfirm={() => setIsModalVisible(false)}
            isCancelButtonVisible isConfirmButtonVisible
        />
    );

    return {
        isModalVisible,
        setIsModalVisible,
        modalDisplay,
    }
}